import { useQuery } from "@tanstack/react-query";
import { useScopeParams } from "./useScopeParams";
import { insightsService } from "@/services/insightsService";

export const useInsightsQuery = () => {
  const { id } = useScopeParams();

  const realQuery = useQuery({
    queryKey: ["insights", id],
    queryFn: async () => {
      if (!id) return [];
      return await insightsService.getInsights(id);
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });

  return {
    insights: realQuery.data || [],
    isLoading: realQuery.isLoading,
    error: realQuery.error,
    refetch: realQuery.refetch,
  };
};
